import React from 'react';
import PropTypes from 'prop-types';
import { TriangleAlert, LockKeyholeOpen } from 'lucide-react';
import { Alert, AlertTitle } from 'components/ui/alert';
import { Button } from 'components/ui/button';
import Locales from 'locales';
import { useIsMutating } from '@tanstack/react-query';

const PlatformLocked = ({ isManualLocked, isRegistrationEnd, isQuotaReached, handleOpenConfirmationModal }) => {
  const isMutating = useIsMutating() > 0;

  const lockReason = isManualLocked
    ? 'manual'
    : isRegistrationEnd
    ? 'registration_end'
    : isQuotaReached
    ? 'quota_reached'
    : null;

  const alertMessage = {
    manual: Locales.preferences.settings.alert.lock_platform,
    registration_end: Locales.base.access_denied.registration_end,
    quota_reached: Locales.base.access_denied.quota_reached,
  }[lockReason];

  return (
    <article className="space-y-4 p-6 bg-white rounded-xl shadow-md">
      <Alert variant="destructive">
        <TriangleAlert className="size-[16px]" />

        <AlertTitle>{alertMessage}</AlertTitle>
      </Alert>

      <p>{Locales.preferences.settings.description_unlock}</p>

      <Button variant="hajj" onClick={handleOpenConfirmationModal} disabled={isMutating}>
        <LockKeyholeOpen />
        {Locales.preferences.settings.button.unlock_platform}
      </Button>
    </article>
  );
};

PlatformLocked.propTypes = {
  isManualLocked: PropTypes.bool,
  isRegistrationEnd: PropTypes.bool,
  isQuotaReached: PropTypes.bool,
  handleOpenConfirmationModal: PropTypes.func.isRequired,
};

export default PlatformLocked;
